import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

import { Text } from '@ingka/common-styles-webc';

export default class SummaryPageTabsStyle {
	public static getStyle(options: { theme: ITheme; hideSkapaTabsOnPrint: boolean }): string {
		const { spacing, color } = options.theme;
		const hiddenSkapaTabsStyle = options.hideSkapaTabsOnPrint
			? css`
					skapa-tabs {
						display: none;
					}
				`
			: null;

		return css`
			${Text.CSS}

			.visuallyHidden {
				border: 0 !important;
				clip: rect(${1 / 16}rem, ${1 / 16}rem, ${1 / 16}rem, ${1 / 16}rem) !important;
				-webkit-clip-path: inset(50%) !important;
				clip-path: inset(50%) !important;
				height: ${1 / 16}rem !important;
				margin: -${1 / 16}rem !important;
				overflow: hidden !important;
				padding: 0 !important;
				position: absolute !important;
				width: ${1 / 16}rem !important;
				white-space: nowrap !important;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				-webkit-user-select: none;
				user-select: none;
			}

			.contentToPrint {
				position: fixed;
				visibility: hidden;
			}

			skapa-inline-message {
				margin-bottom: ${spacing.space100 / 16}rem;
				color: ${color.text.default};
			}

			slot[name='panels'] {
				scroll-margin-top: ${spacing.space250 / 16}rem;
			}

			skapa-tabs > [role='tabpanel'] {
				scroll-margin-top: ${(spacing.space300 * 2) / 16}rem;
			}

			.imageGrid {
				display: grid;
				grid-template-columns: 1fr 1fr;
				row-gap: ${spacing.space200 / 16}rem;
				column-gap: ${spacing.space300 / 16}rem;
			}

			.avoidBreak {
				break-inside: avoid;
			}

			@media print {
				${hiddenSkapaTabsStyle ?? ''}

				.contentToPrint {
					position: relative;
					visibility: visible;
				}

				.subheader {
					font-weight: bold;
					color: ${color.text.dark};
					margin: 0;
					margin-bottom: ${spacing.space50 / 16}rem;
				}
			}
		`;
	}
}
